import { render, staticRenderFns } from "./BranchSale.vue?vue&type=template&id=3323beb0&scoped=true"
import script from "./BranchSale.vue?vue&type=script&lang=js"
export * from "./BranchSale.vue?vue&type=script&lang=js"
import style0 from "./BranchSale.vue?vue&type=style&index=0&id=3323beb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3323beb0",
  null
  
)

export default component.exports